import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import { StyledSelectGroup } from "../../filter/styledFiter";
import FormControl from "@material-ui/core/FormControl";
import { useTranslation } from "react-i18next";

const ServiceSelect = ({
  mappedData,
  checkedService,
  setCheckedService,
  setCheckedCurrency = null,
  setCheckedPaymentSystem = null
}) => {
  const { t } = useTranslation("otherInterface");

  const handleChangeService = (service) => {
    setCheckedService(service);

    if (setCheckedCurrency) {
      setCheckedCurrency(null);
    }

    if (setCheckedPaymentSystem) {
      setCheckedPaymentSystem(null);
    }
  };

  return (
    <StyledSelectGroup>
      <FormControl>
        <Autocomplete
          options={mappedData?.services ? Object.keys(mappedData.services) : []}
          value={checkedService || null}
          onChange={(event, service) => handleChangeService(service)}
          getOptionLabel={(option) => getServiceNameWithNickname(option, mappedData?.services[option].nickname)}
          renderInput={(params) => (
            <TextField {...params} label={t("serviceReletionships.service")} />
          )}
          blurOnSelect
        />
      </FormControl>
    </StyledSelectGroup>
  );
};

export default ServiceSelect;